/**
 * This example creates a default GeoGirafe application, including all the standard configuration from GeoGirafe.
 * You will be able to use all the standard components just by adding them in your html file like this for example:
 *
 * <girafe-about></girafe-about>
 *
 * If you prefer to be more specific a have more control on which component you want to integrate in your application,
 * please see the example described in <custom.ts>.
 *
 **/

import {initializeGeoGirafeCustomStyles, redirectTo, SplashScreen} from '@geogirafe/lib-geoportal/tools';
import {GeoGirafeApp} from '@geogirafe/lib-geoportal/core';
import SitnContextMenuComponent from './components/sitn-context-menu/component';
import SitnThemeComponent from './components/sitn-themes/component';
import SitnWastewaterflowComponent from './components/sitn-wastewaterflow/component';
import SitnMistradistanceComponent from './components/sitn-mistradistance/component';
import SitnVisibilityManagerComponent from './components/sitn-visibility-manager/component';
import SitnFarmingParcelsComponent from './components/sitn-farming-parcels/component';

if (navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('Android')) {
  const redirectUrl = document.querySelector('meta[name=redirect-url]')?.getAttribute('content');
  if (redirectUrl) {
    redirectTo(redirectUrl);
  }
}

// Display the splash-screen
const splash = new SplashScreen();
splash.begin();

// Manage custom css overrides for core components (if any)
initializeGeoGirafeCustomStyles();

// Create the new GeoGirafe Application
const girafeApp = new GeoGirafeApp();

// Wait until the application is ready
girafeApp.isReady().then(() => {
  // Initialize extendedState
  const state = girafeApp.context.stateManager.state;
  state.extendedState.interface = {
    wastewaterflowPanelVisible: false,
    mistradistancePanelVisible: false,
  };
  customElements.define('sitn-context-menu', SitnContextMenuComponent);
  customElements.define('sitn-theme-select', SitnThemeComponent);
  customElements.define('sitn-wastewaterflow', SitnWastewaterflowComponent);
  customElements.define('sitn-mistradistance', SitnMistradistanceComponent);
  customElements.define('sitn-visibility-manager', SitnVisibilityManagerComponent);
  customElements.define('sitn-farming-parcels', SitnFarmingParcelsComponent);
  splash.end();
  // Start the onboarding tour
  girafeApp.context.onBoardingManager.start();
});
